import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CustomButton } from '../../../../utils/Button';
import { slides } from './slides';
import LinkButton from '../../../../utils/LinkButton';
import useSlideProduct from '../../../../hooks/useSlideProduct';

export const AboutSection = () => {
  const { currentIndex, handlePrev, handleNext } = useSlideProduct(slides);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 100000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="lg:px-10 py-6 lg:mx-10 md:mx-10 mx-auto mt-6 lg:flex justify-between items-center bg-[#F5F5F7] lg:rounded-2xl">
      <div className=" lg:w-[50%]">
        <div className="xl:w-[550px] flex flex-col items-center justify-center lg:items-start lg:justify-center">
          <h2 className="text-[28px] lg:text-[43px] lg:w-full font-bold text-start lg:text-start">
            Why SmallSmall?
          </h2>
          <p className="mb-2   text-xl hidden md:block md:px-5 lg:px-0">
            We believe that when you meet your housing and household needs, you
            live better and happier. SmallSmall gives you flexible ways to meet
            those needs today.
          </p>
          <p className="   text-xl text-center md:hidden px-5  mb-6">
            We believe that when you meet your housing and household needs, you
            live better and happier. SmallSmall gives you flexible ways to meet
            those needs today.
          </p>
          <div className="mb-10 lg:mb-0 my-4">
            {/* <CustomButton text="Learn more" className="w-[50%] lg:w-[30%]" /> */}
            <LinkButton link="/how-it-works">Learn more</LinkButton>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center">
        <div className="w-[]">
          <div className="gap-4 mx-auto w-full lg:w-[489px] bg-white p-6   lg:p-12 lg:rounded-[14px] shadow-xl text-sm min-h-[300px] flex flex-col justify-center">
            {slides[currentIndex].content}
          </div>
        </div>

        {/* Controls outside box */}
        {/* <div className="flex flex-col-reverse gap-3 lg:flex lg:flex-row items-center justify-between w-full mt-4 "> */}
        {/* <div>
            <p className="hidden lg:opacity-0">Nothing to </p>
          </div> */}
        {/* Dots */}
        {/* <div className="flex space-x-2">
            {slides.map((_, idx) => (
              <span
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`h-2 w-2 rounded-full cursor-pointer ${
                  currentIndex === idx ? 'bg-black' : 'border border-black'
                }`}
              />
            ))}
          </div> */}
        {/* <div className="flex space-x-4">
            <button
              onClick={handlePrev}
              className="p-1 lg:p-2 rounded-full bg-black shadow"
            >
              <ChevronLeft color="white" />
            </button>

            <button
              onClick={handleNext}
              className="p-1 lg:p-2 rounded-full bg-black  shadow"
            >
              <ChevronRight color="white" />
            </button>
          </div> */}
        {/* </div> */}
      </div>
    </section>
  );
};
